module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/voices/icon-voice-man-40@2x_f3d0807592b635555b3af47cc382f912.png";